export const FINDALLTENANT = 'FINDALLTENANT' // 商户列表查询
export const SHOWTENANT = 'SHOWTENANT'
export const ADDTENANT = 'ADDTENANT'// 新增商户
export const TENANTPWD = 'TENANTPWD'// 重置密码
export const DOWNLOADEXCEL = 'DOWNLOADEXCEL' // 导出数据
export const WAREHOUSEADD = 'WAREHOUSEADD'// 新增仓库
export const GETMENUROLETREES = 'GETMENUROLETREES'
export const SELECTMENUBYYCTCODE = 'SELECTMENUBYYCTCODE'
export const SETMENUBYYCTCODE = 'SETMENUBYYCTCODE'
export const COMBOLIST = 'COMBOLIST'
export const SAVECOMBOLIST = 'SAVECOMBOLIST'
export const SAVESUPPLIERS = 'SAVESUPPLIERS'
export const DELETECOMBO = 'DELETECOMBO'
export const QUERYCOMBOINIFO = 'QUERYCOMBOINIFO'

// 新增商户小程序设置
export const GETAUTHORIZATIONINFO = 'GETAUTHORIZATIONINFO' // (yctCode)   获取小程序设置
export const GETCOMPONENTURL = 'GETCOMPONENTURL' // 获取预授权码，返回授权链接(对应原型上的重新绑定按钮)
export const SYNCINFO = 'SYNCINFO' // 同步信息

// 发布小程序

export const GETTEMPLATELIST = 'GETTEMPLATELIST' // 获取代码模板列表
export const COMMIT = 'COMMIT' // 上传代码(批量的)
export const GETQRCODE = 'GETQRCODE' // 获取体验二维码
export const SETPRIVACYSETTING = 'SETPRIVACYSETTING' // 配置小程序用户隐私保护指引
export const SUBMITAUDIT = 'SUBMITAUDIT' // 提交审核
export const UNDOCODEAUDIT = 'UNDOCODEAUDIT' // 审核撤回
export const GETLATESAUDITSTATUS = 'GETLATESAUDITSTATUS' // 查询最新一次提交审核的状态
export const RELEASE = 'RELEASE' // 发布已通过审核的小程序
export const REVERTCODERELEASE = 'REVERTCODERELEASE' // 小程序版本回退
export const APPLYPLUGIN = 'APPLYPLUGIN' // 小程序版本回退

// 获取授权小程序列表
export const GETYCAUTHORIZATIONAPPLELIST = 'GETYCAUTHORIZATIONAPPLELIST' // 获取授权小程序列表
export const GETYCAUTHORIZATIONAPPLETLOGPAGE = 'GETYCAUTHORIZATIONAPPLETLOGPAGE' // 小程序上传日志

export const MODIFYDOMAIN = 'MODIFYDOMAIN' // 设置服务器域名



// WEBPACK FOOTER //
// ./src/store/merchantManage/types.js